import { defineComponent } from 'vue';
import WorksheetLine from '@/components/document/documentManagement/worksheetBuilderSections/WorksheetLine.vue';
export default defineComponent({
    emits: ['update:worksheet'],
    components: {
        WorksheetLine
    },
    props: {
        worksheet: {
            required: true,
            type: Object
        },
        parentId: {
            required: false,
            type: String,
            default: ''
        }
    },
    data() {
        return {
            worksheetInternal: {}
        };
    },
    created() {
        this.worksheetInternal = this.worksheet;
    }
});
